import React from 'react'
import { NavLink } from 'react-router-dom'

import { UserMenu } from '../UserMenu'
import { LeftArrowIcon } from '../../../../uiKit/icons/Icons'
import { Button } from '@material-ui/core'
import { QCS_LOGIN_URL } from '../../../../configs'
import { isQcsHandoffSession } from '../../../authorization/helpers/qcsHandoffSession'

export const HomeHeader = props => {
  const isLoader = props.accountSettings

  return (
    <div className={props.classes.header}>
      <div
        className={props.classes.headerInner}
        style={!props.backButton ? { justifyContent: 'flex-end' } : null}>
        {props.backButton && (
          <NavLink
            to={props.backUrl ? props.backUrl : '/admin'}
            style={{ textDecoration: 'none' }}>
            <Button className={props.classes.button}>
              <LeftArrowIcon color="var(--color-button-primary)" />
              {props.backUrl && <span>Back</span>}
              {!props.backUrl && <span>Back to bots</span>}
            </Button>
          </NavLink>
        )}
        {!props.backButton && isQcsHandoffSession() && (
          <Button href={QCS_LOGIN_URL} className={`${props.classes.button} ${props.classes.backToQcs}`}>
            <span>Back to home</span>
          </Button>
        )}
        {isLoader && (
          <h4
            className={
              props.backButton ? props.classes.title : props.classes.titleCenter
            }>
            {props.title}
          </h4>
        )}
        {/* Optional control on the right of the top bar (e.g. DEV QCS role
            switcher), before the user menu. */}
        {props.headerAction && (
          <div style={{ display: 'inline-flex', alignItems: 'center', marginRight: 20 }}>
            {props.headerAction}
          </div>
        )}
        <UserMenu minimal={props.minimalUserMenu} />
      </div>
    </div>
  )
}
